<template>
  <div class="collection-section">
    <div class="title-container">
      <div class="title">
        <span v-if="$slots['collection-header']">
          <slot name="collection-header"></slot>
        </span>
        <span v-if="!$slots['collection-header']">เพลย์ลิสต์ปักหมุด</span>
      </div>
      <router-link class="btn btn-link p-0"
        :to="{ path: '/collections', query: { type: `${collectionType}` }}">
        ดูเพิ่มเติม
        <i class="fa fa-chevron-right" />
      </router-link>
    </div>
    <div class="collection-container">
      <router-link class="playlist"
        v-for="(collection, index) in collections"
        :key="index"
        :to="`/collections/${collection.id}`">
        <ImageView
          :source="collection.coverImage"
          imageSize="cover160w90h" />
        <div class="title">{{collection.title}}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import ImageView from '@/image/ImageView.vue';

export default {
  props: {
    collections: {
      type: Array,
      required: true,
    },
    collectionType: {
      type: String,
      required: true,
    },
  },
  components: {
    ImageView,
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/helpers.scss';

.collection-section {
  .title-container {
    margin-bottom: $spacer;
    display: flex;
    justify-content: space-between;
    .title {
      font-size: $font-size-base;
      line-height: 1.2;
      font-weight: normal;
      align-items: center;
      display: flex;
    }
  }
  .collection-container {
    @extend .scrollbar;
    display: flex;
    overflow-x: auto;
    padding-bottom: $spacer / 2;
    .playlist {
      cursor: pointer;
      min-width: calc(100% / 6 - 1.1rem);
      margin-right: $spacer;
      position: relative;
      .title {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        color: white;
        overflow: hidden;
        text-overflow: ellipsis;
        background: linear-gradient(transparent, black 80%);
        padding: 1.5 * $spacer 0.5 * $spacer $spacer 0.5 * $spacer;
      }
    }
    .playlist:last-child {
      margin: 0;
    }
  }
}
@media (max-width: 575.98px) {
  .collection-section {
    margin-top: $spacer * 1.5;
    margin-bottom: 0;
    .title-container {
      margin-bottom: $spacer;
      display: flex;
      .title {
        font-size: $font-size-base * 1.25;
      }
    }
    .collection-container {
      display: flex;
      .playlist {
        flex: 0 0 40%;
        margin-right: $spacer;
        position: relative;
        .title {
          font-size: $font-size-base * 0.875;
        }
      }
    }
  }
}
</style>
